import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { ViLPRProvider } from '../../models';
import { ViLPRProviderDisplayNameTranslationKey } from '../../models/lpr-provider.enum';

/** Maps provider enum values to translation keys for displaying user-friendly names (e.g., "Flock", "Works With Axon") */
@Injectable()
@Pipe({
  name: 'fsLPRProviderTranslate',
  standalone: true,
})
export class LPRProviderNameMapperPipe implements PipeTransform {
  transform(value: ViLPRProvider): ViLPRProviderDisplayNameTranslationKey {
    switch (value) {
      case ViLPRProvider.AXON_VI:
        return ViLPRProviderDisplayNameTranslationKey.AXON_VI;
      case ViLPRProvider.WORKS_WITH_AXON:
        return ViLPRProviderDisplayNameTranslationKey.WORKS_WITH_AXON;
      case ViLPRProvider.VIGILANT:
        return ViLPRProviderDisplayNameTranslationKey.VIGILANT;
      case ViLPRProvider.FLOCK:
        return ViLPRProviderDisplayNameTranslationKey.FLOCK;
      case ViLPRProvider.FLOCK_V3:
        return ViLPRProviderDisplayNameTranslationKey.FLOCK_V3;
      case ViLPRProvider.FUSUS:
        return ViLPRProviderDisplayNameTranslationKey.FUSUS;
      default:
        return value;
    }
  }
}
